/**
 * 组件的emit事件声明
 */
export const emits = [
  /** 点击事件 */
  'click',
];

